// extracted by mini-css-extract-plugin
export default {"modalOverlay":"TK-z","modalContent":"UK-z","header":"VK-z","close":"WK-z"};